export enum ELightboxUrls {
  LIGHTBOX = 'lightbox',
  ELC_LIGHTBOX = 'elc-lightbox',
  PHOTO = 'photo',
  GALLERY = 'gallery',
  PUBLISH = 'publish',
  UNPUBLISH = 'unpublish',
}

export const lightboxBaseUrl = ELightboxUrls.LIGHTBOX;
export const elcLightboxBaseUrl = ELightboxUrls.ELC_LIGHTBOX;
